export default () => ({
  loading: [],
  settings: [],
  valerrors: {},
  flashBanner: null,
  deleteModal: false,
  pictures: [],
  user: {}
});
